import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["data-testid"];
const _hoisted_2 = { class: "text-base font-bold leading-tight text-(--colors-text-heading) dark:text-(--colors-text-white-default)" };
const _hoisted_3 = { class: "text-xs text-(--colors-text-body-subtle)" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'ResumeStat',
    props: {
        value: {},
        label: {},
        testid: {}
    },
    setup(__props) {
        /** One tile of the Résumé's "Indicateurs clés" widget. */
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "flex flex-col items-center justify-center gap-1 rounded-xl border border-(--colors-border-base-soft) px-3 py-4 text-center",
                "data-testid": __props.testid
            }, [
                _createElementVNode("span", _hoisted_2, _toDisplayString(__props.value), 1 /* TEXT */),
                _createElementVNode("span", _hoisted_3, _toDisplayString(__props.label), 1 /* TEXT */)
            ], 8 /* PROPS */, _hoisted_1));
        };
    }
});
